export default __webpack_public_path__ + "static/media/example_csv_file.fff5b41a.csv";